import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { ChangeEvent, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography from "@insite/mobius/Typography";
import Link from "@insite/mobius/Link";
import ADIColors from "@NA/Utils/ADIColors";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";

const mapStateToProps = (state: CustomApplicationState) => ({});

const mapDispatchToProps = {};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;
export interface requestquoteconfirmationStyle{
    requestQuotesubmit?:InjectableCss
    quoteNumber?:InjectableCss
    textSize?:InjectableCss
    quotenumber?:InjectableCss
    quotenumberdiv?:InjectableCss
    quoteContainer?:InjectableCss
    quoteTitle?:InjectableCss
    quoteDescription?:InjectableCss
}
export const requestQuoteConfirmationStyle: requestquoteconfirmationStyle ={
    requestQuotesubmit:{
        css:css`
        font-family: 'Nunito Sans';
        font-size: 36px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.17;
        letter-spacing: normal;
        color: ${ADIColors.darkBlue1};
        margin: 0 0 9px 0;
        padding-bottom:15px;
        `
    },
    quoteNumber:{
        css:css`
        font-size: 14px;
        font-weight: bolder;
        padding-bottom:20px;
        `
    },
    quotenumberdiv:{
        css:css`
        margin-bottom:20px;
        `
    },
    quoteContainer:{
        css:css`
        display: block;
        width: 100%;
        margin-bottom: 20px;
        `
    },
    quoteTitle:{
        css:css`
        font-size: 14px;
        font-style: normal;
        display: block;
        width: 100%;
    `
    },
    textSize:{
        css:css`
        font-size: 14px;
        font-style: normal;
        display: block;
        width: 100%;
        `
    },
    quoteDescription:{
        css:css`
        font-size: 14px;
        font-style: normal;
        display: block;
        width: 100%;
        `
    },
    quotenumber:{
        css:css`
        padding-bottom:10px;
        `
    }
}
const styles=requestQuoteConfirmationStyle
const ADIRequestQuoteConfirmation = ({}:Props) =>{
    const [quoteNumberRFQ, setquoteNumberRFQ] = useState<any>([]);
    const getLocalStorageData = () => {
        let quoteNumber = localStorage.getItem("quoteNumberRFQ");             
        if (quoteNumber) {
            setquoteNumberRFQ(quoteNumber);
        }
    };
    useEffect(() => {
        getLocalStorageData();
    }, []);

    return (
        <>
              <StyledWrapper {...styles.quoteContainer}>
                <StyledWrapper {...styles.quoteTitle}>
                    <Typography as="h1" {...styles.requestQuotesubmit}>{translate(`Quote Request Submitted`)}</Typography>
                </StyledWrapper>
                <StyledWrapper >
                    <Typography {...styles.quoteDescription}>{translate(`Thank you for submitting a request for a new quote with ADI. A team member will review your submission, and you will receive your quote via email when complete.`)}</Typography>
                </StyledWrapper>
                <StyledWrapper>
                    <Typography {...styles.textSize}>{translate(`Your Quote Number is `)}<Typography {...styles.quoteNumber}>{quoteNumberRFQ}.</Typography></Typography>
                </StyledWrapper>
                </StyledWrapper>
         </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ADIRequestQuoteConfirmation),
    definition: {
        group: "My Account",
        displayName: "ADI Request Quote Confirmation",
    },
};

export default widgetModule;
